/* OB Tie Dye guide: tidy repeats (Oct 7 2026).
   Runs after the feed is expanded into window.OB_GUIDE_ITEMS and before ob-guide-v3.js boots. Works on every guide page.
   1. Daily repeats (Recurring? Yes, every day of the week, not starred, not a seasonal category) count as weekly stuff,
      so they live on the Happy hours + weekly pages instead of filling the main list once per day.
      Example: La La Noodle Daily To-Go Special, nightly comedy club house shows.
   2. Long-running displays (Recurring? Yes in Festival, Art Market, Theater, Film or Space, open 5+ days a week, running 14+ days,
      not tagged Residency) show once, at their next date, running through their last date, instead of once per day.
      Example: Ethel M Cactus Garden Lights, Enchant, Bellagio Conservatory, pumpkin patches, museum exhibits.
      Once-a-week things (a Wednesday night market, Friday movie night) keep their own dates.
   Nothing in the sheet changes. Undo: remove the ob-guide-tidy.js script tag from snippets/ob-guide-v3.liquid. */
(function(){
  try{
    var raw=window.OB_GUIDE_RAW_FEED||[],items=window.OB_GUIDE_ITEMS;
    if(!items||!items.length||!raw.length)return;
    var SEASONAL=/^(Festival|Art Market|Theater \+ Performing Arts|Film|Space \+ Stargazing)$/,WEEKLY_CATS=/^(Happy Hour|Trivia|Karaoke)$/;
    function yes(v){return v===true||/^(yes|true|1)$/i.test(String(v==null?'':v).trim())}
    function tagList(r){var t=r.tags;return Array.isArray(t)?t.join(','):String(t||'')}
    function dayCount(v){var s=String(v||'').toLowerCase();if(/daily|nightly|every ?day/.test(s))return 7;var m=s.match(/\b(mon|tue|wed|thu|fri|sat|sun)/g);if(!m)return 0;var u={};m.forEach(function(x){u[x]=1});return Object.keys(u).length}
    function baseKey(k){return String(k||'').replace(/\|\d{4}-\d{2}-\d{2}$/,'')}
    var daily={},longrun={};
    for(var i=0;i<raw.length;i++){
      var r=raw[i];if(!r||!r.key||!yes(r.recurring))continue;
      var cat=r.cat||'',k=String(r.key);
      if(WEEKLY_CATS.test(cat))continue;
      if(SEASONAL.test(cat)){
        var a=Date.parse(r.start_date),b=Date.parse(r.active_through||r.end_date||'');
        if(dayCount(r.days)>=5&&!isNaN(a)&&!isNaN(b)&&(b-a)/864e5>=14&&!/residency/i.test(tagList(r)))longrun[k]=r;
        continue;
      }
      if(dayCount(r.days)>=7&&!yes(r.starred)&&!yes(r.here))daily[k]=r;
    }
    var groups={},now=Date.now();
    for(var n=0;n<items.length;n++){
      var it=items[n];if(!it)continue;
      var full=String(it.key||''),bk=baseKey(full),hit=daily[full]?full:(daily[bk]?bk:'');
      if(hit){it.weekly=true;var pv=daily[hit].priority||daily[hit].Priority;if(pv&&!it.priority)it.priority=String(pv);continue}
      var lk=longrun[full]?full:(longrun[bk]?bk:'');
      if(lk){(groups[lk]=groups[lk]||[]).push(it)}
    }
    var drop=[];
    Object.keys(groups).forEach(function(g){
      var list=groups[g].slice().sort(function(x,y){return Date.parse(x.start)-Date.parse(y.start)});
      var keep=null,lastEnd=0;
      list.forEach(function(x){var e=Date.parse(x.end||x.start);if(!isNaN(e)&&e>lastEnd)lastEnd=e;if(!keep&&!isNaN(e)&&e>now)keep=x});
      if(!keep||list.length<2)return;
      keep.end=new Date(lastEnd).toISOString();keep.ob_thru=true;
      list.forEach(function(x){if(x!==keep){x.__obDrop=1;drop.push(x)}});
    });
    if(drop.length){
      for(var d=items.length-1;d>=0;d--){if(items[d]&&items[d].__obDrop)items.splice(d,1)}
    }
    window.OB_GUIDE_TIDY={daily:Object.keys(daily).length,longrun:Object.keys(groups).length,dropped:drop.length};
  }catch(e){if(window.console)console.error('[OB guide] tidy',e)}
})();
